/**
 * React App Entry Point
 * Small Manufacturing ERP - Master Data Management
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Initialize i18n before React renders. Await full initialization (all
// namespaces loaded) so the first paint never sees an unloaded namespace and
// raw translation keys cannot leak into the DOM. `.finally` renders the app
// regardless of init outcome so a failed locale fetch never bricks the UI.
import { i18nInitialized } from './shared/i18n/config';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Failed to find the root element');
}

void i18nInitialized.finally(() => {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
});
